"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Capacity = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const card_1 = require("./card");
const buttons_1 = require("../../atoms/buttons");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const CapacityWrapper = styled_components_1.default.div `
  width: 100%;

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    padding-top: 1rem;
  }

  & > *:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacings.m};
  }
  p {
    text-align: center;
  }
  button {
    width: auto;
    min-width: 220px;
    margin-top: 0.5rem;
    margin-bottom: 1rem;
    float: right;
    @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
      width: calc(100% - 2rem);
      margin: 0 1rem 1rem 1rem;
      float: none;
    }
  }
`;
const Capacity = ({ compositionTitle, subscriptions, capacities, capacityTypes, calculateAvailableCapacity, onCapacitiesChange, inputValueResolver, buttonLabel, onSubmit, header }) => {
    const [, currentSubscriptions] = subscriptions.reduce(([legacy, current], subscription) => {
        if (["vip", "pro"].includes(subscription)) {
            return [legacy, [...current, subscription]];
        }
        return [[...legacy, subscription], current];
    }, [[], []]);
    return ((0, jsx_runtime_1.jsxs)(CapacityWrapper, { children: [header && (0, jsx_runtime_1.jsx)(typography_1.P, { children: header }, void 0), currentSubscriptions.map((subscription, index) => ((0, jsx_runtime_1.jsx)(card_1.Card, { tableIndex: index + 3, subscription: subscription, title: compositionTitle, capacities: capacities, capacityTypes: capacityTypes, inputValueResolver: inputValueResolver, calculateAvailableCapacity: calculateAvailableCapacity, onCapacitiesChange: onCapacitiesChange }, index))), (0, jsx_runtime_1.jsx)(buttons_1.Button, { variant: "primary", onClick: onSubmit, children: buttonLabel }, void 0)] }, void 0));
};
exports.Capacity = Capacity;
//# sourceMappingURL=index.js.map